import React, { useState } from "react";
import { Clock, Mail, Phone } from "lucide-react";

export default function Contact() {
    const [submitted, setSubmitted] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        const fd = new FormData(e.currentTarget);

        const res = await fetch("/contact.php", {
            method: "POST",
            body: fd,
        });

        if (res.ok) {
            setSubmitted(true);
        } else {
            alert("There was a problem sending your message.");
        }
    };

    if (submitted) {
        return (
            <main className="max-w-xl mx-auto px-4 py-12">
                <div className="rounded-2xl border p-6 bg-white">
                    <h1 className="text-2xl font-bold">Thanks! We’ll be in touch.</h1>
                    <p className="text-slate-600 mt-2">
                        Your message has been sent. A member of our friendly team will call
                        or email you shortly.
                    </p>
                    <div className="mt-6 flex gap-3 text-sm">
                        <a href="#/" className="rounded-xl px-4 py-2 border">
                            Back to Home
                        </a>
                        <a
                            href="tel:01785716133"
                            className="inline-flex items-center gap-2 rounded-xl px-4 py-2 bg-slate-900 text-white"
                        >
                            <Phone className="w-4 h-4" /> 01785 716133
                        </a>
                    </div>
                </div>
            </main>
        );
    }

    return (
        <main className="max-w-2xl mx-auto px-4 py-12">
            <h1 className="text-3xl font-bold">Book a callback with us.</h1>
            <p className="text-slate-600 mt-2">
                It all begins with a chat. Maybe it’s time to renew your contract?
                Maybe you just fancy a change. Whatever it is, booking a call with our
                helpful team is a great way to get the ball rolling.
            </p>

            <form onSubmit={onSubmit} className="mt-8 grid gap-4">
                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium">
                            First Name <span className="text-red-600">(required)</span>
                        </label>
                        <input
                            name="firstName"
                            required
                            className="mt-1 w-full rounded-xl border px-3 py-2"
                            placeholder="First Name"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium">
                            Last Name <span className="text-red-600">(required)</span>
                        </label>
                        <input
                            name="lastName"
                            required
                            className="mt-1 w-full rounded-xl border px-3 py-2"
                            placeholder="Last Name"
                        />
                    </div>
                </div>

                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium">
                            Phone <span className="text-red-600">(required)</span>
                        </label>
                        <input
                            name="phone"
                            type="tel"
                            required
                            className="mt-1 w-full rounded-xl border px-3 py-2"
                            placeholder="e.g. 01785 716133"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium">
                            Email <span className="text-red-600">(required)</span>
                        </label>
                        <input
                            name="email"
                            type="email"
                            required
                            className="mt-1 w-full rounded-xl border px-3 py-2"
                            placeholder="you@example.com"
                        />
                    </div>
                </div>

                <div>
                    <label className="block text-sm font-medium">
                        Best time to speak <span className="text-red-600">(required)</span>
                    </label>
                    <div className="mt-1 flex items-center gap-3">
                        <Clock className="w-4 h-4 text-slate-500" />
                        <span> Around </span>
                        <input
                            name="bestTime"
                            type="time"
                            required
                            className="rounded-xl border px-3 py-2"
                        />
                        <span className="text-slate-500">in Greenwich Mean Time</span>
                    </div>
                </div>

                <div>
                    <label className="block text-sm font-medium">
                        Subject <span className="text-red-600">(required)</span>
                    </label>
                    <input
                        name="subject"
                        required
                        className="mt-1 w-full rounded-xl border px-3 py-2"
                        placeholder="What would you like to chat about?"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium">
                        Message <span className="text-red-600">(required)</span>
                    </label>
                    <textarea
                        name="message"
                        required
                        rows={5}
                        className="mt-1 w-full rounded-xl border px-3 py-2"
                        placeholder="Tell us a little about what you’re looking for…"
                    />
                </div>

                <label className="inline-flex items-center gap-2 text-sm">
                    <input type="checkbox" name="newsletter" className="rounded border" />
                    <span>Add me to your Newsletter</span>
                </label>

                <div className="pt-2 flex gap-3">
                    <button
                        type="submit"
                        className="rounded-2xl bg-slate-900 text-white px-4 py-2"
                    >
                        Send
                    </button>
                    <a
                        href="mailto:claytoncontracts@gmail.com"
                        className="inline-flex items-center gap-2 rounded-2xl border px-4 py-2"
                    >
                        <Mail className="w-4 h-4" />
                        Email us
                    </a>
                    <a
                        href="tel:01785716133"
                        className="inline-flex items-center gap-2 rounded-2xl border px-4 py-2"
                    >
                        <Phone className="w-4 h-4" />
                        01785 716133
                    </a>
                </div>
            </form>
        </main>
    );
}
